import getApiClient from '@/plugins/api-client'

export default {
    loadDay() {
        const self = this,
            api = getApiClient(self.$store),
            day = self.$route.params.day

        api.get('events/happening_on', {
            params: {
                'date': day
            }
        })
            .then(result => {
                self.events = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
    goToEditEvent: function(event) {
        const profileSearches = [];

        event.profileSearches.forEach(profile => {
            profile.profiles = event.jobs.filter(job => {
                return job.profileSearch.id === profile.id
            }).map(job => {
                return job.workProfile
            })

            profileSearches[profile.id] = profile
        })

        this.$store.state.jobsSynced = false
        this.$store.commit('updateProfileSearches', profileSearches)
        this.$store.commit('setCreatingEvent', event.id)
        this.$router.push({name: 'ContractorJobForm', params: {id: event.id}})
    },
    cloneEvent(event) {
        const self = this,
          api = getApiClient(self.$store)

        api.post(`/events/${event.id}/clone`, {})
          .then(response => {
              const newEventId = response.data.id
              this.$router.push({name: 'ContractorCloneEventForm', params: {id: newEventId}})
          })
          .catch(() => {
              this.showCloneErrorMessage = true
          })
    },
}
